import { render, staticRenderFns } from "./buttonBox.vue?vue&type=template&id=20a2b813&"
import script from "./buttonBox.vue?vue&type=script&lang=js&"
export * from "./buttonBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports